import React, { useState, useEffect } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, FormControl, InputLabel, Select, MenuItem, Button, Tooltip, Checkbox, Menu, MenuItem as MuiMenuItem } from "@mui/material";
import { Star, StarHalf, StarBorder } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviews } from "../../Redux/Slice/reviewsSlice"; 
import Pagination from "../../Components/Pagination";

const Reviews = () => {
  const dispatch = useDispatch();
  const { reviews = [], loading, error } = useSelector((state) => state.reviews);
  const [searchTerm, setSearchTerm] = useState("");
  const [dropdownValue, setDropdownValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 5;
  const [selectedReviews, setSelectedReviews] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    dispatch(fetchReviews());
  }, [dispatch]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleDropdownChange = (event) => {
    setDropdownValue(event.target.value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleCheckboxChange = (event, reviewId) => {
    if (event.target.checked) {
      setSelectedReviews([...selectedReviews, reviewId]);
    } else {
      setSelectedReviews(selectedReviews.filter((id) => id !== reviewId));
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    setAnchorEl(null);
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStars = rating % 1 >= 0.5 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;
    return (
      <>
        {[...Array(fullStars)].map((_, index) => (
          <Star key={`full-${index}`} sx={{ color: "#FFD700" }} />
        ))}
        {[...Array(halfStars)].map((_, index) => (
          <StarHalf key={`half-${index}`} sx={{ color: "#FFD700" }} />
        ))}
        {[...Array(emptyStars)].map((_, index) => (
          <StarBorder key={`empty-${index}`} sx={{ color: "#FFD700" }} />
        ))}
      </>
    );
  };

  const filteredReviews = Array.isArray(reviews)
    ? reviews.filter(
        (review) =>
          review.product?.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          review.user?.email.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = filteredReviews.slice(indexOfFirstReview, indexOfLastReview);
console.log(currentReviews);

  return (
    <Box sx={{ padding: 2, minHeight: "100vh" }}>
      <Typography variant="h4" gutterBottom>
        Reviews
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
        <TextField
          label="Search..."
          variant="outlined"
          value={searchTerm}
          onChange={handleSearch}
          sx={{ width: { xs: "100%", sm: "200px", md: "250px" }, height: "40px" }}
        />

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Status</InputLabel>
            <Select value={dropdownValue} onChange={handleDropdownChange} label="Filter">
              <MenuItem value="option1">Pending</MenuItem>
              <MenuItem value="option2">Fullfilled</MenuItem>
              <MenuItem value="option3">Rejected</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: { xs: "100%", sm: 200, md: 220 } }}>
            <InputLabel>Filter</InputLabel>
            <Select value={dropdownValue} onChange={handleDropdownChange} label="Filter">
              <MenuItem value="option1">20</MenuItem>
              <MenuItem value="option2">40</MenuItem>
              <MenuItem value="option3">60</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : error ? (
        <Typography color="error">Error: {error}</Typography>
      ) : (
        <>
          <TableContainer>
            <Table>
              <TableHead sx={{ backgroundColor: "#f7f8f9" }}>
                <TableRow>
                  <TableCell>
                    <Checkbox />
                  </TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Reviewer</TableCell>
                  <TableCell>Rating</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentReviews.length > 0 ? (
                  currentReviews.map((review) => (
                    <TableRow key={review.id}>
                      <TableCell>
                        <Checkbox
                          checked={selectedReviews.includes(review.id)}
                          onChange={(e) => handleCheckboxChange(e, review.id)}
                        />
                      </TableCell>
                      <TableCell>{review.product?.name || "Product Name Unavailable"}</TableCell>
                      <TableCell>
                        <a href={`mailto:${review.user?.username || ""}`}>{review.user?.username || "No Email"}</a>
                      </TableCell>
                      <TableCell>{renderStars(review.rating)}</TableCell>
                      <TableCell>{new Date(review.created_at).toLocaleDateString()}</TableCell>
                      <TableCell align="right">
                        <Button variant="contained" sx={{ backgroundColor: "#3bb77e", marginRight: 1 }}>
                          View Details
                        </Button>
                        <Tooltip title="More options" arrow>
                          <Button onClick={handleMenuClick}>&#8230;</Button>
                        </Tooltip>
                        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                          <MuiMenuItem onClick={handleEdit}>Edit</MuiMenuItem>
                          <MuiMenuItem onClick={handleDelete}>Delete</MuiMenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6}>No reviews found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination totalPages={Math.ceil(filteredReviews.length / reviewsPerPage)} currentPage={currentPage} onPageChange={handlePageChange} />
        </>
      )}
    </Box>
  );
};

export default Reviews;
